const md5 = require("md5");

const browserFingerprint: () => string = () => {
  const browserFeatures = [];
  const browser = (navigator ? navigator : { dummy: "navigator" }) as {
    [index: string]: any;
  };

  for (const key in browser) {
    try {
      browserFeatures.push(
        `${key}:${
          typeof browser[key] === "object"
            ? JSON.stringify(browser[key])
            : browser[key]
        }`
      );
    } catch (e) {}
  }

  return md5(browserFeatures.join(","));
};

export default browserFingerprint;
